import React, { useState, createContext } from 'react'

interface IAction {
  children: React.ReactNode
}

type ActionData = {
  ACTION_ID: string
  ACTION_NAME: string
  SET_ACTION_NAME: (action: string) => void
  updateValue: (id: string) => void
}

export const ActionContext = createContext({} as ActionData)

export function ActionProvider({ children }: IAction) {
  const [ACTION_ID, SET_ACTION_ID] = useState('')
  const [ACTION_NAME, SET_ACTION_NAME] = useState('')

  const updateValue = (id: any) => {
    if (ACTION_ID === id) {
      return SET_ACTION_ID('')
    }
    SET_ACTION_ID(id)
  }

  return (
    <ActionContext.Provider
      value={{
        ACTION_ID,
        ACTION_NAME,
        SET_ACTION_NAME,
        updateValue
      }}
    >
      {children}
    </ActionContext.Provider>
  )
}
